import React from 'react'
import { NumberConvert } from '../../../common/numberConvert'

const OrderCount = ({ store, data }) => {
  return (
    <div className='bg-stone-600/60 rounded-md flex flex-col gap-3 p-5 duration-150'>

      <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
        {store} 주문 관리 현황
      </div>

      <div className='flex gap-5 items-center'>
        <div>
          {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
        </div>
        <div>
          <div>주문 완료</div>
          <div className='flex gap-1'>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data0 + data.data2))} 건`}</p>
            <p>|</p>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data1 + data.data3))} 개`}</p>
          </div>
        </div>        
      </div>

      <div className='flex gap-5 items-center'>
        <div>
          {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
        </div>
        <div>
          <div>주문 삭제</div>
          <div className='flex gap-1'>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data4 + data.data6))} 건`}</p>
            <p>|</p>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data5 + data.data7))} 개`}</p>
          </div>
        </div>        
      </div>

    </div>
  )
}

export default OrderCount